import React from "react";

import queryString from "query-string";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {ReactSession} from "react-client-session";
import {Helpers} from "../../config/Helpers";
import $ from "jquery";
import {toast} from "react-toastify";
import {isAndroid, isIOS, isMobile} from "react-device-detect";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";

class PaymentDetails  extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            CatatanOrder: '',
            DisplayOrderName: '',
            paymentDetails: '',
            kodeTransaksiOrder: '',
            kodePaymentGateway: '',
            isModalOpen: false,
            metodePembayaran: '',
            harga: '',
            biayaAdmin: '',
            totalPembayaran: '',
            bayarSebelum: '',
            sisaWaktuPembayaran: '',
            virtualAccount: '',
            OVOPhoneNumber: '',
            urlParam: queryString.parse(window.location.search),

            time: {},
            seconds: 0,
            openTime: false
        }
        this.timer = 0;
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';
            const kodePayment = (this.state.urlParam.payment) ? base64_decode(this.state.urlParam.payment) : '';
            const type = (this.state.urlParam.type) ? this.state.urlParam.type : '';

            this.setState({
                kodeTransaksiOrder: kodeOrder,
                kodePaymentGateway: kodePayment,
                type: type
            }, () => {
                this.getDetailPayment();
            });
        }
    }

    getDetailPayment = () => {
        Helpers.getListOrder('yes',this.state.kodeTransaksiOrder,'','','').then(res => {
            this.setState({
                orderData: res[0],
                CatatanOrder: res[0].CatatanOrder,
                DisplayOrderName: res[0].DisplayOrderName,
                harga: res[0].TotalHargaOrder,
                biayaAdmin: res[0].BiayaAdmin,
            });
        });

        if(this.state.kodePaymentGateway == 'KPG-0014'){
            Helpers.getListOrder('yes',this.state.kodeTransaksiOrder,'','','').then(res => {
                if(res[0].SisaWaktuPembayaranSeconds > 0){
                    this.setState({
                        paymentDetails: res[0],
                        metodePembayaran: 'OVO',
                        totalPembayaran: 'Rp ' + res[0].TotalHargaOrder,
                        bayarSebelum: '',
                        virtualAccount: '',
                        openTime: true,
                        seconds: parseInt(res[0].SisaWaktuPembayaranSeconds)/1000,
                    }, () => {
                        let timeLeftVar = this.secondsToTime(this.state.seconds);
                        this.setState({
                            time: timeLeftVar
                        }, () => {
                            this.startTimer();
                        });
                    });
                }else{
                    this.setState({
                        paymentDetails: res[0],
                        metodePembayaran: 'OVO',
                        totalPembayaran: 'Rp ' + res[0].TotalHargaOrder,
                        bayarSebelum: '',
                        virtualAccount: '',
                        sisaWaktuPembayaran: 'Waktu pembayaran habis, order telah dibatalkan atau dalam proses menunggu konfirmasi pembayaran.',
                        openTime: false,
                        seconds: 0,
                    });
                }
            })
        }else{
            Helpers.getDetailPayment(this.state.kodeTransaksiOrder,this.state.kodePaymentGateway).then(res => {
                if(res[0].ExpiredSeconds > 0){
                    this.setState({
                        paymentDetails: res[0],
                        metodePembayaran: res[0].Bank,
                        totalPembayaran: 'Rp ' + res[0].TotalPembayaran,
                        totalPembayaran: 'Rp ' + res[0].TotalPembayaran,
                        totalPembayaran: 'Rp ' + res[0].TotalPembayaran,
                        bayarSebelum: res[0].ExpiredFormatView,
                        virtualAccount: res[0].AccountNo,
                        openTime: true,
                        seconds: parseInt(res[0].ExpiredSeconds)/1000,
                    }, () => {
                        let timeLeftVar = this.secondsToTime(this.state.seconds);
                        this.setState({
                            time: timeLeftVar
                        }, () => {
                            this.startTimer();
                        });
                    });
                }else{
                    this.setState({
                        paymentDetails: res[0],
                        metodePembayaran: res[0].Bank,
                        totalPembayaran: 'Rp ' + res[0].TotalPembayaran,
                        bayarSebelum: res[0].ExpiredFormatView,
                        virtualAccount: res[0].AccountNo,
                        sisaWaktuPembayaran: 'Waktu pembayaran habis, order telah dibatalkan atau dalam proses menunggu konfirmasi pembayaran.',
                        openTime: false,
                        seconds: 0,
                    });
                }
            })
        }
    };

    checkPaymentStatus = () => {
        Helpers.getDetailPaymentCheckNew(this.state.kodeTransaksiOrder).then(res => {
            if(res.length > 0){
                if(res[0].status == 'paid'){
                    clearInterval(this.timer);

                    this.setState({
                        sisaWaktuPembayaran: 'Pembayaran berhasil diterima, halaman akan dialihkan ke detail order.',
                        openTime: false
                    }, () => {
                        window.location.href = './account-orders-details?trxid=' + base64_encode(this.state.kodeTransaksiOrder);
                    });
                }
            }
        })
    };

    handleOVORequest = () => {
        this.handleModal();

        Helpers.createVA(this.state.kodeTransaksiOrder, this.state.kodePaymentGateway, this.state.OVOPhoneNumber).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    this.setState({
                        OVOPhoneNumber: ''
                    });
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        });

        setTimeout(() => {
            if(isMobile) {
                if (isAndroid) {
                    const url = "intent://ovo.id/#Intent;scheme=https;package=ovo.id;end";
                    window.location.replace(url);
                } else if (isIOS) {
                    window.location.replace("ovo://");

                    setTimeout(() => {
                        window.location.replace(
                            "https://apps.apple.com/ID/app/id1142114207?mt=8"
                        );
                    }, 10000);
                } else {
                    toast.error(Helpers.MSG_ERROR_OVO);
                }
            }else{
                toast.error(Helpers.MSG_ERROR_OVO);
            }
        }, 1000);
    };

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
            sisaWaktuPembayaran: ((this.state.time.h.toString().length < 2) ? '0'+this.state.time.h : this.state.time.h) + ':' + ((this.state.time.m.toString().length < 2) ? '0'+this.state.time.m : this.state.time.m) + ':' + ((this.state.time.s.toString().length < 2) ? '0'+this.state.time.s : this.state.time.s)
        });

        if(parseInt(seconds)%3 == 0){
            this.checkPaymentStatus();
        }

        if (seconds == 0) {
            clearInterval(this.timer);
            this.setState({
                openTime: false
            });
            window.location.reload();
        }
    }

    handleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    handleShopee = () => {
        if(isMobile) {
            var win = window.open(this.state.virtualAccount, '_blank');
            win.focus();
        }else{
            toast.error(Helpers.MSG_ERROR_SHOPEEPAY);
        }
    }

    handleCC = () => {
        window.location.href = this.state.virtualAccount;
    }

    handleKoinWorks = () => {
        window.location.href = './koinworks-loan-otp?user='+this.state.sessUserCode+'&loanid='+this.state.virtualAccount+'&payment='+this.state.kodePaymentGateway+'&order='+this.state.kodeTransaksiOrder;
    }

    handleCopyVA = () => {
        navigator.clipboard.writeText(this.state.virtualAccount);
        toast.success("Virtual Account berhasil di copy");
    };

    render() {
        return (
            <>
                <Modal
                    size={'md'}
                    isOpen={this.state.isModalOpen}
                    toggle={() => {this.handleModal()}}>
                    <ModalBody style={{'padding': 'unset'}}>
                        <div className="row mt-15" style={{'margin': 'unset'}}>
                            <div className="col-lg-12">
                                <div className="input-style mb-20">
                                    <label>Masukkan Nomor OVO</label>
                                    <input value={this.state.OVOPhoneNumber} onChange={e => this.setState({OVOPhoneNumber: e.target.value})}
                                           placeholder="e.g. 081234567890"
                                           min={0}
                                           type="number"/>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={() => {this.handleOVORequest()}}>
                            Submit
                        </Button>
                        {' '}
                        <Button onClick={() => {this.handleModal()}}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
                <main className="main">
                    <div className="page-header breadcrumb-wrap">
                        <div className="container">
                            <div className="breadcrumb">
                                <a href="./" rel="nofollow"><i className="fi-rs-home mr-5"></i>Beranda</a>
                                <span></span> Pembayaran
                            </div>
                        </div>
                    </div>
                    <div className="container mb-80 mt-15">
                        <div className="row">
                            <div className="col-lg-4 m-auto">
                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border" style={{'margin-bottom': '0px'}}>
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Informasi Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <small className="text-muted">Nomor Virtual Account</small>
                                                    <div className="va-container">
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.virtualAccount}
                                                    </h6>
                                                    {
                                                        (this.state.kodePaymentGateway == 'KPG-0014' && this.state.openTime) && (
                                                            <button className="submit submit-auto-width" onClick={() => {this.handleModal()}}
                                                                    type="button">Send Request
                                                            </button>
                                                        )
                                                    }
                                                    {
                                                        (this.state.kodePaymentGateway == 'KPG-0015' && this.state.openTime) && (
                                                            <button className="submit submit-auto-width" onClick={() => {this.handleShopee()}}
                                                                    type="button">Buka Aplikasi Shopee
                                                            </button>
                                                        )
                                                    }
                                                    {
                                                        (this.state.kodePaymentGateway == 'KPG-0016' && this.state.openTime) && (
                                                            <button className="submit submit-auto-width" onClick={() => {this.handleCC()}}
                                                                    type="button">Proses Pembayaran
                                                            </button>
                                                        )
                                                    }
                                                    {
                                                        (this.state.kodePaymentGateway == 'KPG-0017' && this.state.openTime) && (
                                                            <button className="submit submit-auto-width" onClick={() => {this.handleKoinWorks()}}
                                                                    type="button">Konfirmasi OTP
                                                            </button>
                                                        )
                                                    }
                                                    {
                                                        ((this.state.kodePaymentGateway !== 'KPG-0014' && this.state.kodePaymentGateway !== 'KPG-0015' && this.state.kodePaymentGateway !== 'KPG-0016' && this.state.kodePaymentGateway !== 'KPG-0017') && this.state.openTime) && (

                                                            <button
                                                                type="button"
                                                                className="btn-copy-va"
                                                                onClick={this.handleCopyVA}
                                                            >
                                                                <i className="fi fi-rs-copy mr-5"></i>
                                                                Salin
                                                            </button>
                                                        )
                                                    }
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <small className="text-muted">Total Pembayaran</small>
                                                    <h6 className="text-brand text-align-left">
                                                            {this.state.totalPembayaran}
                                                    </h6>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <small className="text-muted">Bayar Sebelum</small>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.bayarSebelum}
                                                    </h6> <br></br>
                                                    <h6 className="text-brand text-align-left">
                                                        {
                                                            this.state.sisaWaktuPembayaran
                                                        }
                                                    </h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="border p-md-4 cart-totals ml-30">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0"> Rincian Pembayaran</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="payment-method-row">
                                                <td className="image product-thumbnail align-middle">
                                                    <div className="icon5"></div>
                                                </td>
                                                <td className="align-middle">
                                                    <small className="text-muted">Metode</small>
                                                    <h6 className="text-brand mb-0">
                                                        {this.state.metodePembayaran}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="divider-2 payment-divider"></div>
                                                </td>
                                            </tr>
                                            <tr className="payment-total-row">
                                                <td>
                                                    <h6 className="text-muted mb-0">
                                                        Harga
                                                    </h6>
                                                </td>

                                                <td className="text-end">
                                                    <h5 className="text-brand mb-0">
                                                        Rp {this.state.harga}
                                                    </h5>
                                                </td>
                                            </tr>
                                            <tr className="payment-total-row">
                                                <td>
                                                    <h6 className="text-muted mb-0">
                                                        Biaya Admin
                                                    </h6>
                                                </td>

                                                <td className="text-end">
                                                    <h5 className="text-brand mb-0">
                                                        Rp {this.state.biayaAdmin}
                                                    </h5>
                                                </td>
                                            </tr>

                                            <tr className="payment-total-row payment-grand-total">
                                                <td>
                                                    <h6 className="text-muted mb-0">
                                                        Total Pembayaran
                                                    </h6>
                                                </td>

                                                <td className="text-end">
                                                    <h5 className="text-brand mb-0 text-orange">
                                                        {this.state.totalPembayaran}
                                                    </h5>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <div className="border p-md-4 cart-totals ml-30 mb-15">
                                    <div className="table-responsive">
                                        <table className="table no-border">
                                            <tbody>
                                            <tr>
                                                <td className="cart_total_label" colSpan={3}>
                                                    <div className="container-title">
                                                        <div className="title-badge"></div>
                                                        <h6 className="text-muted m-0">Detail Transaksi</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="image product-   thumbnail">
                                                    <div className="icon"></div>

                                                </td>
                                                <td>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.CatatanOrder}
                                                    </h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="image product-thumbnail">
                                                    <div className="icon1"></div>
                                                </td>
                                                <td>
                                                    <h6 className="text-brand text-align-left">
                                                        {this.state.DisplayOrderName}
                                                    </h6>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default PaymentDetails;